


























































import { defineComponent, onUnmounted, ref } from '@nuxtjs/composition-api'
import { VueMaskDirective } from 'v-mask'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

import '@/assets/styles/datepicker.scss'
import InputError from '@/components/Inputs/new-design/InputError.vue'
import { FormMask } from '@/contracts/FormMask'

export default defineComponent({
  components: { InputError, DatePicker },
  directives: {
    mask: VueMaskDirective,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'DD.MM.YYYY',
    },
    placeholder: {
      type: String,
      default: '',
    },
    mask: {
      type: [String, Array],
      default: FormMask.NotSet,
    },
    error: {
      type: [String, Boolean],
      default: '',
    },
    testId: {
      type: String,
      default: '',
    },
  },
  setup(_, ctx) {
    const isFocused = ref<boolean>(false)
    const inputDate = ref<HTMLInputElement | null>(null)
    const isOpen = ref<boolean>(false)

    const onChange = ($event: string) => {
      ctx.emit('input-change', $event)
      ctx.emit('input', $event)
    }

    const onInput = (event: InputEvent) => {
      const target = event.target as HTMLInputElement
      ctx.emit('input-change', target.value)
      ctx.emit('input', target.value)
    }

    const onFocusClick = () => {
      inputDate.value?.focus()
    }

    const onFocus = () => {
      isFocused.value = true
      ctx.emit('focus')
    }

    const onBlur = () => {
      isFocused.value = false
      ctx.emit('blur')
    }

    const onClose = () => {
      isOpen.value = false
    }

    const onPrependClick = (e: MouseEvent) => {
      isOpen.value = !isOpen.value
      e.stopPropagation()
    }

    onUnmounted(() => {
      ctx.emit('unmounted')
    })

    return {
      onFocusClick,
      inputDate,
      isOpen,
      isFocused,
      onChange,
      onClose,
      onInput,
      onFocus,
      onBlur,
      onPrependClick,
    }
  },
})
